import styled from 'styled-components'
import {white} from '@modifi/constants/colors'
import {H5} from '@modifi/ui'

export const Wrapper = styled.section`
  padding: 0 0 40px;
`

export const Content = styled.article`
  opacity: 0;
  visibility: hidden;
  max-height: 0;
  overflow: hidden;
  transition: all 0.5s ease;
  padding: 0 10px;
  ${({show}) =>
    show
      ? `
        opacity: 1;
        visibility: visible;
        max-height: 1000px;
        overflow: visible;
      `
      : ''}
`

export const EmptyState = styled.div`
  text-align: center;
  background: ${({isTabVisible}) => (isTabVisible ? white : 'transparent')};
  padding: ${({isTabVisible}) => (isTabVisible ? '140px' : '70px')} 0;
  margin: 0 -10px;

  ${H5} {
    margin: 40px 0 10px;
  }
`
